import gql from 'graphql-tag';
export default gql`
  query industries {
    industries {
      name
      docId
    }
  }
`;
